const colorMatcher = {
  1: ['primavera', 'quente'],
  2: ['primavera', 'brilhante'],
  3: ['primavera', 'clara'],
  4: ['outono', 'suave'],
  5: ['outono', 'escuro'],
  6: ['outono', 'quente'],
  7: ['inverno', 'brilhante'],
  8: ['inverno', 'frio'],
  9: ['inverno', 'escuro'],
  10: ['verao', 'frio'],
  11: ['verao', 'claro'],
  12: ['verao', 'suave']
}

const constrastMatcher = {
  0: 'main',
  1: 'alto',
  2: 'medio',
  3: 'baixoclaro',
  4: 'baixoescuro',
  5: 'medioalto',
  6: 'mediobaixo'
}

export const getColorTemplate = id => {
  const value = colorMatcher[id]
  let colorImages = []

  for (let i = 1; i < 11; i++) {
    let tempImage = `/assets/color/${value[0]}/${value[1]}/${i}.jpg`
    colorImages.push(tempImage)
  }

  return colorImages
}

export const getContrastTemplate = id => {
  const value = constrastMatcher[id]

  const first = `/assets/contrast/${value}/first.jpg`
  const second = `/assets/contrast/${value}/second.jpg`
  const description = '/assets/contrast/main/description.jpg'

  return [first, second, description]
}



// WEBPACK FOOTER //
// ./src/services/ColoringAndContrastHelpers.js